import Vue from 'vue'
// import router from '@/router'
// import store from '@/store'
import { PopupManager } from '@/components/utils/popup'

let instance
const instances = []
let seed = 1

const builder = (VueInstance, router, store) => {
  const CustomInstance = Vue.extend(VueInstance)
  const { popupConfig = { modal: true } } = VueInstance

  const CustomDialog = (options = {}) => {
    if (Vue.prototype.$isServer) return 0

    const userOnClose = options.onClose

    const id = `xue-dialog_${seed++}`
    const popupZIndex = PopupManager.nextZIndex()

    options.onClose = () => {
      CustomDialog.close(id, userOnClose)
      if (popupConfig.modal) PopupManager.closeModal(id)
    }

    instance = new CustomInstance({ data: options, router, store })

    instance.id = id

    // if (isVNode(instance.message)) {
    //   instance.$slots.default = [instance.message]
    //   instance.message = null
    // }

    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
    instance.vm.visible = true
    instance.dom = instance.vm.$el
    instance.dom.style.zIndex = PopupManager.nextZIndex()
    instances.push(instance)
    if (popupConfig.modal) PopupManager.openModal(id, popupZIndex, instance.dom)
    return instance.popupReturn ? instance.popupReturn() : instance.vm
  }

  CustomDialog.close = (id, userOnClose) => {
    for (let i = 0, len = instances.length; i < len; i++) {
      if (id === instances[i].id) {
        if (typeof userOnClose === 'function') {
          userOnClose(instances[i])
        }
        instances.splice(i, 1)
        break
      }
    }
  }

  CustomDialog.closeAll = () => {
    for (let i = instances.length - 1; i >= 0; i--) {
      instances[i].close()
    }
  }

  return CustomDialog
}

export default builder



// WEBPACK FOOTER //
// ./src/modules/dialog-builder/index.js